import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';

const Strings = require('../../../../app/shared/Strings');
const ServerRequest = require('../../actions/request');
const SignInStore = require('../../stores/SignInStore');
const SupportUtil = require('../../util/support');
import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    minimizeBreakpoint: PropTypes.oneOf(['sm', 'md']),
};
const defaultProps = {
    minimizeBreakpoint: 'sm',
};

class HelpDropdown extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            signInStoreState: SignInStore.getState()
        };

        this.selectHandler = this.selectHandler.bind(this);
        this.unsubscribes = [
            SignInStore.listen(this.onSignInStoreChange.bind(this))
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onSignInStoreChange(state) {
        this.setState({ signInStoreState: state });
    }

    selectHandler(redirectTo) {
        switch (redirectTo) {
            case 'kb': {
                window.open(SupportUtil.getKbUrl(), '_blank');
                break;
            }
            case 'portal': {
                window.open(SupportUtil.getSupportUrl(), '_blank');
                break;
            }
            case 'ticket': {
                window.open(SupportUtil.getSupportNewTicketUrl(), '_blank');
                break;
            }
            case 'discord': {
                window.open(SupportUtil.getDiscordUrl(), '_blank');
                break;
                
            }
            case '/terms':
            case '/privacy': {
                window.open(redirectTo, '_blank');
                break;
            }
            default: {
                return;
            }
        }
    }

    render() {
        const menuItems = [
            {
                content: (
                    <>
                        {Strings['en'].dashboard.help.KNOWLEDGE_BASE}
                        <AccessibleIcon className="fa fa-external-link fr" label={Strings['en'].common.OPEN_NEW_TAB} />
                    </>
                ),
                text: Strings['en'].dashboard.help.KNOWLEDGE_BASE,
                value: 'kb',
            },
            {
                content: (
                    <>
                        {Strings['en'].dashboard.help.CUSTOMER_PORTAL}
                        <AccessibleIcon className="fa fa-external-link fr" label={Strings['en'].common.OPEN_NEW_TAB} />
                    </>
                ),
                text: Strings['en'].dashboard.help.CUSTOMER_PORTAL,
                value: 'portal'
            },
            {
                content: (
                    <>
                        {Strings['en'].dashboard.help.SUBMIT_TICKET}
                        <AccessibleIcon className="fa fa-external-link fr" label={Strings['en'].common.OPEN_NEW_TAB} />
                    </>
                ),
                text: Strings['en'].dashboard.help.SUBMIT_TICKET,
                value: 'ticket'
            },
            {
                content: (
                    <>
                        {Strings['en'].dashboard.help.DISCORD}
                        <AccessibleIcon className="fa fa-external-link fr" label={Strings['en'].common.OPEN_NEW_TAB} />
                    </>
                ),
                text: Strings['en'].dashboard.help.DISCORD,
                value: 'discord'
            },
            {
                content: (
                    <>
                        {Strings['en'].dashboard.help.TERMS}
                        <AccessibleIcon className="fa fa-external-link fr" label={Strings['en'].common.OPEN_NEW_TAB} />
                    </>
                ),
                text: Strings['en'].dashboard.help.TERMS,
                value: '/terms'
            },
            {
                content: (
                    <>
                        {Strings['en'].dashboard.help.PRIVACY}
                        <AccessibleIcon className="fa fa-external-link fr" label={Strings['en'].common.OPEN_NEW_TAB} />
                    </>
                ),
                text: Strings['en'].dashboard.help.PRIVACY,
                value: '/privacy' 
            },
        ];

        let textButtonDispClass;
        let iconButtonDispClass;
        if (this.props.minimizeBreakpoint === 'sm' || !this.props.minimizeBreakpoint) {
            textButtonDispClass = 'd-none d-sm-inline';
            iconButtonDispClass = 'd-inline d-sm-none';
        }
        else if (this.props.minimizeBreakpoint === 'md') {
            textButtonDispClass = 'd-none d-lg-inline';
            iconButtonDispClass = 'd-inline d-lg-none';
        }
        else {
            textButtonDispClass = 'd-none d-sm-inline';
            iconButtonDispClass = 'd-inline d-sm-none';
        }

        return (
            <span className="help-dropdown">
                <Wrapper
                    className='AriaMenuButton'
                    onSelection={this.selectHandler}
                >
                    <Button className='AriaMenuButton-trigger AriaMenuButton-trigger--bare-text'>
                        <span className={textButtonDispClass}>
                            {Strings['en'].dashboard.help.MENU_TITLE}
                        </span>
                        <span className={iconButtonDispClass}>
                            <span className="fa fa-question-circle-o" aria-hidden="true" />
                            <span className="sr-only">help</span>
                        </span>
                    </Button>
                    <Menu>
                        <ul className='AriaMenuButton-menu AriaMenuButton-menu--flushRight'>
                            {menuItems.map((item) =>
                                <li className='AriaMenuButton-menuItemWrapper' key={item.value}>
                                    <MenuItem
                                        className='AriaMenuButton-menuItem'
                                        value={item.value}
                                        text={item.text}
                                    >
                                        {item.content}
                                    </MenuItem>
                                </li>
                            )}
                        </ul>
                    </Menu>
                </Wrapper>
            </span>
        );
    }
}

HelpDropdown.propTypes = propTypes;
HelpDropdown.defaultProps = defaultProps;

export default HelpDropdown;
